import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

// 웹 환경값을 frontCore 런타임 설정에 주입한다(부수효과). 첫 API 호출 전에 실행되도록 맨 위에서 import 한다.
import '@/lib/env';
import { initCapsLockHint } from '@/lib/ui/capsLockHint';
import { initFontScale } from '@/lib/ui/fontScale';
import { router } from '@/router';
import './index.css';

// 사용자가 고른 글씨 크기를 첫 그림 전에 얹는다 — 뒤에 적용하면 권장 크기로 한 번 그려졌다 바뀐다.
initFontScale();
initCapsLockHint();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // v1 은 5분 폴링으로 갱신했다. 여기서는 캐시 수명을 명시하고 필요한 화면에서만 주기 갱신한다.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root 엘리먼트를 찾을 수 없습니다.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
